<!-- Note: This file should only contains NG-TEMPLATES-->
<!-- Note: Here let-data to be the type of 'CsDdTemplate'-->

<ng-template #btnTransparent let-data="togglerConfig" let-menuData="menuConfig">
    <div class="toggler-wrapper">
        <span>
            <span [ngClass]="{'link-text': data['templateData']['isLinkText']}" translate>{{data['templateData']['text']}}</span>
            <span *ngIf="menuData['isMultiChoice']">&nbsp;({{menuData['selectedItemsCount']}}/{{menuData['totalItemsCount']}})</span>
        </span>
        <span><i class="fa fa-angle-down"></i></span>
    </div>
</ng-template>

<ng-template #btnPrimary let-data="togglerConfig" let-menuData="menuConfig">
    <div class="btn btn-primary btn-small">
        <span translate>{{data['templateData']['text']}}</span>
    </div>
</ng-template>
